export const MAX_TRUNCATED_TEXT_LENGTH = 500;
export const MAX_DISPLAYED_SPECIALITIES = 4;
export const MAX_DISPLAYED_FILES = 3;
export const MAX_DISPLAYED_DOCTORS = 4;
export const MAX_DISPLAYED_CLINICS = 4;
export const MAX_DISPLAYED_DEPARTMENTS = 2;
